import { Button } from "@jugl-web/ui-kit";
import { cx } from "@jugl-web/utils";

export const OptionButton = ({
  label,
  isActive,
  onClick,
}: {
  label: string;
  isActive?: boolean;
  onClick?: () => void;
}) => (
  <Button
    onClick={onClick}
    size="sm"
    className={cx(
      "h-[40px] border-[1px] border-solid border-transparent font-normal hover:border-primary-200 hover:bg-primary",
      {
        "border-grey-400 text-dark hover:bg-transparent hover:text-dark":
          !isActive,
      }
    )}
    variant={isActive ? "primary" : "secondary"}
  >
    {label}
  </Button>
);
